import { CONFIG } from "../config";

/**
 * Normalizes an event object into a standard format.
 */
function normalizeEvent(event) {
  const startStr = event.start.dateTime || event.start.date;
  const endStr = event.end.dateTime || event.end.date;

  return {
    id: event.id,
    title: event.summary || event.title || "Untitled Event",
    description: event.description || "",
    start: new Date(startStr),
    end: new Date(endStr),
    isAllDay: !event.start.dateTime
  };
}

/**
 * Fetches events from Google Calendar if configured, otherwise falls back to static list.
 */
export async function getEvents() {
  const calendarId = CONFIG.GOOGLE_CALENDAR_ID;
  const apiKey = CONFIG.GOOGLE_CALENDAR_API_KEY;

  if (!calendarId || !apiKey) {
    console.log("Google Calendar ID or API Key is missing. Using static fallback events.");
    return CONFIG.FALLBACK_EVENTS.map(normalizeEvent).sort((a, b) => a.start - b.start);
  }

  try {
    // We want to fetch events from Google Calendar. We request singleEvents=true to expand recurring events,
    // and order by startTime.
    const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(
      calendarId
    )}/events?key=${apiKey}&singleEvents=true&orderBy=startTime`;

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Google Calendar API returned status ${response.status}`);
    }

    const data = await response.json();
    if (!data.items) {
      return [];
    }

    return data.items.map(normalizeEvent).sort((a, b) => a.start - b.start);
  } catch (error) {
    console.error("Failed to fetch Google Calendar events, falling back to static list:", error);
    return CONFIG.FALLBACK_EVENTS.map(normalizeEvent).sort((a, b) => a.start - b.start);
  }
}

/**
 * Extracts the closest future event from a list of events.
 */
export function getNextEvent(events) {
  const now = new Date();
  // Find events that haven't ended yet, sorted by start time
  const upcomingEvents = events
    .filter(event => event.end > now)
    .sort((a, b) => a.start - b.start);
  
  return upcomingEvents.length > 0 ? upcomingEvents[0] : null;
}

/**
 * Finds if there is an event currently in progress (active now).
 */
export function getActiveEvent(events) {
  const now = new Date();
  return events.find(event => event.start <= now && event.end >= now) || null;
}

